import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtTime } from "../../lib/api";
import { PageHeader, Loading } from "../../components/common";

export default function Corrections() {
  const [status, setStatus] = useState("pending");
  const [rows, setRows] = useState(null);
  const load = () => api.get("/corrections", { params: { status } }).then((r) => setRows(r.data));
  useEffect(() => { load(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);
  const decide = async (c, approve) => {
    const note = window.prompt(approve ? "Note (optional):" : "Reason for rejection:") ?? null;
    if (note === null) return;
    try { await api.post(`/corrections/${c.id}/decide`, { approve, note }); toast.success(approve ? "Approved and applied" : "Rejected"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHeader title="Correction Requests" sub="Requests submitted by participants after the registration period. Approved changes are applied and logged.">
        {["pending", "approved", "rejected"].map((s) => <button key={s} className={`btn-sm ${status === s ? "btn-primary" : "btn-ghost"}`} onClick={() => setStatus(s)}>{s}</button>)}
      </PageHeader>
      {!rows ? <Loading /> : (
        <div className="grid gap-3" data-testid="corrections-list">
          {rows.map((c) => (
            <div key={c.id} className="sfap-card p-4 flex flex-wrap justify-between gap-3">
              <div>
                <div className="font-semibold">{c.participant_name} · <span className="font-mono text-xs">{c.participant_code}</span></div>
                <div className="text-sm">{Object.entries(c.changes).map(([k, v]) => `${k} → "${v}"`).join(", ")}{c.attendance_id ? " (for a specific meeting)" : ""}</div>
                <div className="text-xs text-stone-500">Reason: {c.reason} · {fmtTime(c.created_at)}{c.decided_by ? ` · ${c.status} by ${c.decided_by}` : ""}</div>
              </div>
              {c.status === "pending" && <div className="flex gap-2"><button className="btn-sm btn-primary" onClick={() => decide(c, true)} data-testid={`approve-${c.id}`}>Approve</button><button className="btn-sm btn-ghost" onClick={() => decide(c, false)} data-testid={`reject-${c.id}`}>Reject</button></div>}
            </div>
          ))}
          {!rows.length && <p className="text-stone-500">No {status} requests.</p>}
        </div>
      )}
    </div>
  );
}
